module.exports = __webpack_public_path__ + "img/user.4f87348c.svg";